import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HomeCard from '../HomeCard/HomeCard';
import './HomeSection.css';
import '../AboutUs/AboutUs.css'; // Import AboutUs styles for consistency

import trainingIcon from '../../images/icons/training.svg';
import devIcon from '../../images/icons/dev.svg';
import consultIcon from '../../images/icons/consult.svg';
import LogoCardSection from '../LogoCardSection/LogoCardSection';
import ContentCardSection from '../ContentCardSection/ContentCardSection';
import TestimonialSection from '../TestimonialSection/TestimonialSection';
import Contact from '../Contact/Contact';
import Services from '../Services/Services';
import AboutUs from '../AboutUs/AboutUs';
import CommonChallenges from '../CommonChallenges/CommonChallenges';
import Industries from '../Industries/Industries';
import TrajectoryStats from '../TrajectoryStats/TrajectoryStats';
import GrowthChallenges from '../GrowthChallenges/GrowthChallenges';
import Solutions from '../Solutions/Solutions';
import GrowthAccompaniment from '../GrowthAccompaniment/GrowthAccompaniment';
import { useLanguage } from '../../context/LanguageContext';
import StepCard from '../Services/StepCard';

const HomeSection: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    // Force canvas reinitialization when component mounts
    const event = new Event('resize');
    window.dispatchEvent(event);
  }, []);

  const cards = [
    {
      title: t('home.consulting.title'),
      text: t('home.consulting.text'),
      icon: consultIcon
    },
    {
      title: t('home.development.title'),
      text: t('home.development.text'),
      icon: devIcon
    },
    {
      title: t('home.training.title'),
      text: t('home.training.text'),
      icon: trainingIcon
    },
  ];

  return (
    <section className="home-section">
      <Container fluid="lg">
        <div id="about">
          {/* <AboutUs /> */}
          {/* We need to add these like this in this order below*/}
          <TrajectoryStats />
          <GrowthChallenges />
          <Solutions />
           {/* Process Steps Section */}
        <div className="process-section">
          <h3 className="section-subtitle text-center">{t('services.process.title.part1')}</h3>
          <h3 className="section-subtitle text-center process-title-highlight">{t('services.process.title.part2')}</h3>
          <Row className="process-steps-container">
            <Col lg={4} md={6} xs={12} className="process-step-col">
              <StepCard
                stepNumber={1}
                title={t('services.process.step1.title')}
                description={t('services.process.step1.description')}
              />
            </Col>
            <Col lg={4} md={6} xs={12} className="process-step-col">
              <StepCard
                stepNumber={2}
                title={t('services.process.step2.title')}
                description={t('services.process.step2.description')}
              />
            </Col>
            <Col lg={4} md={6} xs={12} className="process-step-col">
              <StepCard
                stepNumber={3}
                title={t('services.process.step3.title')}
                description={t('services.process.step3.description')}
              />
            </Col>
          </Row>
        </div>
          {/* <GrowthAccompaniment /> */}
        </div>
        {/* <Row className="g-4 justify-content-center align-items-stretch">
          {cards.map((card, index) => (
            <Col key={index} xs={12} sm={6} lg={4}>
              <HomeCard {...card} />
            </Col>
          ))}
        </Row> */}
      </Container>

      <div id="industries-section">
        <Industries />
      </div>
      <div id="challenges-section">
        {/* <CommonChallenges /> */}
      </div>
      <div id="services-section">
        <Services />
      </div>
      <div id="clientes-section">
        <LogoCardSection />
      </div>
      {/* <ContentCardSection />
      <TestimonialSection /> */}
      <Contact />
    </section>
  );
};

export default HomeSection;
